import { render, staticRenderFns } from "./ManageUserWorkspacesPage.vue?vue&type=template&id=8b040464"
import script from "./ManageUserWorkspacesPage.vue?vue&type=script&lang=ts"
export * from "./ManageUserWorkspacesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports